import { useEffect } from "react";

let sharedAudioContext: AudioContext | null = null;

const getAudioContext = (): AudioContext | null => {
  try {
    if (sharedAudioContext) return sharedAudioContext;
    const AudioContextClass =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!AudioContextClass) return null;
    sharedAudioContext = new AudioContextClass();
    return sharedAudioContext;
  } catch {
    return null;
  }
};

export const playSuccessSound = async () => {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;

    if (ctx.state === "suspended") {
      await ctx.resume();
    }

    const now = ctx.currentTime;

    const playTone = (frequency: number, startAt: number, duration: number) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency, now + startAt);
      gain.gain.setValueAtTime(0, now + startAt);
      gain.gain.linearRampToValueAtTime(1.0, now + startAt + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + startAt + duration);
      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.onended = () => {
        oscillator.onended = null;
        oscillator.disconnect();
        gain.disconnect();
      };
      oscillator.start(now + startAt);
      oscillator.stop(now + startAt + duration);
    };

    playTone(880, 0, 0.12);
    playTone(1320, 0.12, 0.18);
  } catch {
    // 音声再生に失敗しても処理は続行する
  }
};

/**
 * ブラウザのautoplay policy対策。
 * マウント後の最初のユーザー操作でAudioContextをunlockする。
 */
export const useUnlockAudioOnUserGesture = () => {
  useEffect(() => {
    const unlock = () => {
      const ctx = getAudioContext();
      if (ctx && ctx.state === "suspended") {
        ctx.resume().catch(() => {
          // resumeの失敗は無視する（次のユーザー操作で再試行される）
        });
      }
    };

    window.addEventListener("touchstart", unlock, {
      once: true,
      passive: true,
    });
    window.addEventListener("click", unlock, { once: true, passive: true });

    return () => {
      window.removeEventListener("touchstart", unlock);
      window.removeEventListener("click", unlock);
    };
  }, []);
};
